import { Grid } from "@material-ui/core";
import { InputTextMaster } from "App/Component/ui";
import React, { Suspense, useEffect, useState } from "react";
import "App/Style/login.scss";
import { defaultToastError, isNull } from "App/utils/helpers";
import { BASE_URL, instance2 } from "App/constants";
import { useHistory } from "react-router-dom";
import { getToken, getUserName, setCookieLogin } from "App/utils/cookies";
import { FullLoading } from "App/Component/layout/Wrapper/Wrapper";
import { useSelector } from "react-redux";
import { buildApiBaseUrl } from "App/utils/apiBaseUrl";

function Login() {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [disabled, setDisabled] = useState(false);
  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };
  let history = useHistory();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(true);
    try {
      await instance2
        .post("/users/login", {
          ...formData,
        })
        .then((res) => {
          setCookieLogin(res.data);
        })
        .then(async () => {
          history.push("/dashboard");
          setDisabled(false);
        });
    } catch (error) {
      defaultToastError(error?.response?.data?.pesan);
      setDisabled(false);
    }
  };

  const master = useSelector(({ master }) => master);
  const favIcon = master.setting.favicon;

  useEffect(() => {
    const token = getToken();
    const userName = getUserName();
    if (token && userName) {
      history.push("/dashboard");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    document.title = process.env.REACT_APP_NAMA_RUMAH_SAKIT;
    const link = document.querySelector("link[rel~='icon']");
    if(!isNull(favIcon)){
      link.href = favIcon;
    }
  }, [favIcon]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Suspense fallback={<FullLoading isLoading={true} />}>
      <div className='login-page'>
        <div className='wrapper'>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}>
            <img
              src={`${buildApiBaseUrl(BASE_URL, process.env.REACT_APP_PORT)}/images/${process.env.REACT_APP_LOGO_NAME}`}
              alt='Logo Asha'
              style={{
                height: "60px",
              }}
            />
          </div>
          <div className='header'>Silahkan Login</div>
          <form onSubmit={(e) => handleSubmit(e)}>
            <Grid container spacing={1}>
              <Grid item sm={12}>
                <InputTextMaster
                  name='username'
                  label='USERNAME'
                  id='username'
                  autoFocus={true}
                  value={formData.username}
                  onChange={handleChange("username")}
                  placeholder='Username'
                  style={{
                    padding: "0.8rem 1rem",
                    fontSize: "16px",
                  }}
                />
              </Grid>
              <Grid item sm={12}>
                <InputTextMaster
                  name='password'
                  label='PASSWORD'
                  id='password'
                  type='password'
                  value={formData.password}
                  onChange={handleChange("password")}
                  placeholder='******'
                  style={{
                    padding: "0.8rem 1rem",
                    fontSize: "16px",
                  }}
                />
              </Grid>

              <Grid container direction='row' alignItems='center'>
                <button
                  type='submit'
                  className={`button-login ${disabled ? "loading" : ""}`}>
                  {disabled ? "Loading..." : "LOGIN"}
                </button>
              </Grid>
            </Grid>
          </form>
        </div>
      </div>
    </Suspense>
  );
}

export default Login;
